import { render } from "./IdleTimePopup.vue?vue&type=template&id=d56ade86&scoped=true&ts=true"
import script from "./IdleTimePopup.vue?vue&type=script&lang=ts"
export * from "./IdleTimePopup.vue?vue&type=script&lang=ts"

import "./IdleTimePopup.vue?vue&type=style&index=0&id=d56ade86&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56ade86"]])

export default __exports__